import { render, staticRenderFns } from "./vip-monthly-salary.vue?vue&type=template&id=2061ead3&scoped=true"
import script from "./vip-monthly-salary.vue?vue&type=script&lang=js"
export * from "./vip-monthly-salary.vue?vue&type=script&lang=js"
import style0 from "./vip-monthly-salary.vue?vue&type=style&index=0&id=2061ead3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2061ead3",
  null
  
)

export default component.exports